/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type TimeSlot = "T_00_00" | "T_00_30" | "T_01_00" | "T_01_30" | "T_02_00" | "T_02_30" | "T_03_00" | "T_03_30" | "T_04_00" | "T_04_30" | "T_05_00" | "T_05_30" | "T_06_00" | "T_06_30" | "T_07_00" | "T_07_30" | "T_08_00" | "T_08_30" | "T_09_00" | "T_09_30" | "T_10_00" | "T_10_30" | "T_11_00" | "T_11_30" | "T_12_00" | "T_12_30" | "T_13_00" | "T_13_30" | "T_14_00" | "T_14_30" | "T_15_00" | "T_15_30" | "T_16_00" | "T_16_30" | "T_17_00" | "T_17_30" | "T_18_00" | "T_18_30" | "T_19_00" | "T_19_30" | "T_20_00" | "T_20_30" | "T_21_00" | "T_21_30" | "T_22_00" | "T_22_30" | "T_23_00" | "T_23_30" | "%future added value";
export type SuggestionActionReschedule_payload = {
    readonly calendarId: string | null;
    readonly externalEventId: string | null;
    readonly betterTime: {
        readonly date: string;
        readonly timeSlot: TimeSlot;
    } | null;
    readonly nearestAlternateTime: {
        readonly date: string;
        readonly timeSlot: TimeSlot;
    } | null;
    readonly eventStartWeek: string | null;
    readonly event: {
        readonly calendarIds: ReadonlyArray<string>;
        readonly isAllDay: boolean | null;
        readonly eventKey: {
            readonly externalEventId: string;
        };
        readonly startTime: {
            readonly millis: number;
            readonly dateOrDateTime: string;
            readonly timeZone: string | null;
        };
        readonly endTime: {
            readonly millis: number;
        };
        readonly title: string | null;
        readonly attendees: ReadonlyArray<{
            readonly displayName: string | null;
            readonly urnValue: string;
        }>;
        readonly organizer: {
            readonly urnValue: string;
        } | null;
    } | null;
    readonly " $refType": "SuggestionActionReschedule_payload";
};
export type SuggestionActionReschedule_payload$data = SuggestionActionReschedule_payload;
export type SuggestionActionReschedule_payload$key = {
    readonly " $data"?: SuggestionActionReschedule_payload$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"SuggestionActionReschedule_payload">;
};



const node: ReaderFragment = (function () {
    var v0 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "externalEventId",
        "storageKey": null
    } as any, v1 = [
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "date",
            "storageKey": null
        } as any,
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "timeSlot",
            "storageKey": null
        } as any
    ], v2 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "millis",
        "storageKey": null
    } as any, v3 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "urnValue",
        "storageKey": null
    } as any;
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "metadata": null,
        "name": "SuggestionActionReschedule_payload",
        "selections": [
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "calendarId",
                "storageKey": null
            },
            (v0 /*: any*/),
            {
                "alias": null,
                "args": null,
                "concreteType": "DayTimeSlot",
                "kind": "LinkedField",
                "name": "betterTime",
                "plural": false,
                "selections": (v1 /*: any*/),
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "concreteType": "DayTimeSlot",
                "kind": "LinkedField",
                "name": "nearestAlternateTime",
                "plural": false,
                "selections": (v1 /*: any*/),
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "eventStartWeek",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "concreteType": "Event",
                "kind": "LinkedField",
                "name": "event",
                "plural": false,
                "selections": [
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "calendarIds",
                        "storageKey": null
                    },
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "isAllDay",
                        "storageKey": null
                    },
                    {
                        "alias": null,
                        "args": null,
                        "concreteType": "EventKey",
                        "kind": "LinkedField",
                        "name": "eventKey",
                        "plural": false,
                        "selections": [
                            (v0 /*: any*/)
                        ],
                        "storageKey": null
                    },
                    {
                        "alias": null,
                        "args": null,
                        "concreteType": "EventTime",
                        "kind": "LinkedField",
                        "name": "startTime",
                        "plural": false,
                        "selections": [
                            (v2 /*: any*/),
                            {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "dateOrDateTime",
                                "storageKey": null
                            },
                            {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "timeZone",
                                "storageKey": null
                            }
                        ],
                        "storageKey": null
                    },
                    {
                        "alias": null,
                        "args": null,
                        "concreteType": "EventTime",
                        "kind": "LinkedField",
                        "name": "endTime",
                        "plural": false,
                        "selections": [
                            (v2 /*: any*/)
                        ],
                        "storageKey": null
                    },
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "title",
                        "storageKey": null
                    },
                    {
                        "alias": null,
                        "args": null,
                        "concreteType": "Attendee",
                        "kind": "LinkedField",
                        "name": "attendees",
                        "plural": true,
                        "selections": [
                            {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "displayName",
                                "storageKey": null
                            },
                            (v3 /*: any*/)
                        ],
                        "storageKey": null
                    },
                    {
                        "alias": null,
                        "args": null,
                        "concreteType": "Attendee",
                        "kind": "LinkedField",
                        "name": "organizer",
                        "plural": false,
                        "selections": [
                            (v3 /*: any*/)
                        ],
                        "storageKey": null
                    }
                ],
                "storageKey": null
            }
        ],
        "type": "SuggestionActionReschedulePayload",
        "abstractKey": null
    } as any;
})();
(node as any).hash = 'eebcd902f4f6b56dcd688a78cb5f4eba';
export default node;
